<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import IconButton from "@elements/IconButton.svelte";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  export let onClick: VoidFunction | null = null;
</script>

<!-- Template ----------------------------------------------------------------->

<IconButton
  icon={{ name: "triangle-right" }}
  size="medium"
  class="bg-white mr-3"
  {onClick}
/>
